// extracted by mini-css-extract-plugin
export default {"appWrapper":"AppLayout_appWrapper__gMZ8t"};